module.exports = __webpack_public_path__ + "nu.650aaffc474764ae687d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/nu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/nu.svg
// module chunks = styles